import { render } from "./mped-amortization-main-asset-chooser.vue?vue&type=template&id=e088ff58"
import script from "./mped-amortization-main-asset-chooser.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-main-asset-chooser.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-main-asset-chooser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e088ff58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e088ff58', __exports__)) {
    api.reload('e088ff58', __exports__)
  }
  
  module.hot.accept("./mped-amortization-main-asset-chooser.vue?vue&type=template&id=e088ff58", () => {
    api.rerender('e088ff58', render)
  })

}


export default __exports__